import { StandardSpinner } from '@dreryk/react-components';

import { EGabinetNewsTag, useEGabinetNewsTag } from './NewsCard.hooks';

type NewsCardListElementNewsTagRenderProps = {
   newsCardListElementTag: EGabinetNewsTag | undefined;
   egabinetNewsTagError: Error | undefined;
};

type NewsCardListElementNewsTagLoaderProps = {
   readonly tagId: string;
   readonly children: (renderProps: NewsCardListElementNewsTagRenderProps) => JSX.Element;
};

export const NewsCardListElementNewsTagLoader = (props: NewsCardListElementNewsTagLoaderProps): JSX.Element => {
   const { egabinetNewsTag, egabinetNewsTagError, egabinetNewsTagLoading } = useEGabinetNewsTag(props.tagId);

   if (egabinetNewsTagLoading) {
      return <StandardSpinner />;
   }

   return props.children({
      newsCardListElementTag: egabinetNewsTag,
      egabinetNewsTagError: egabinetNewsTagError,
   });
};
